// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","597":"projects","636":"landing"}[chunkId] + "." + {"594":"15a65ff0","597":"977549c7","636":"ea954dba"}[chunkId] + ".js";
};